<template>
  <div class="inp-comment">
    <div class="img-upload">
      <v-file-input
        label="File input w/ chips"
        chips
        multiple
        accept="image/png, image/jpeg"
        @change="onChangeImg"
      ></v-file-input>
    </div>
    <c-Input v-model="comment" :placeholder="t('message.commentGuide')" @keyup.enter="onClickComment" :name="'comment'"/>
    <c-btn01 class="upload-ty" @click="onClickComment"/>
  </div>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import TimelineService from "@/services/timeline.service";
import utils from "@/common/Utils";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps(['btnText', 'idx'])
const emit = defineEmits(['confirmComment'])

//bind
let file = null
const comment = ref('')
const snackbar = ref(false)
const snackText = ref('')

//function
function onChangeImg(e: Event){
  file = (e.target as HTMLInputElement).files[0];
  /*
  if (file) {
    const tempObj = {idx:0, src:URL.createObjectURL(file)}
  }
   */
}

function onClickComment(){
  if(utils.isEmpty(comment.value) && !file){
    snackText.value = t('message.enterTextOrAttachImage')
    snackbar.value = true
    return
  }
  const idx = props.idx
  const formData = new FormData();
  if(file)
    formData.append("file", file);
  formData.append("timelineIdx", idx);
  formData.append("comment", comment.value);
  formData.append('companyIdx', localStorage.getItem('companyIdx'));

  TimelineService.insertTimelineComment(formData).then(
    (response) => {
      if(response.success) {
        comment.value = ''
        file = null
        emit('confirmComment', response.result)
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}
</script>


<style lang="scss">
.inp-comment {
  position:sticky;
  top:-2rem;
  display:flex;
  background:#fff;
  z-index:2;
  .img-upload{
    .v-input{
      display:block;
      .v-input__prepend{
        margin:0;
        .v-icon{
          display:block;
          width:5rem;
          height:5rem;
          line-height:5rem;
          text-align:center;
          color:var(--color-white);
          background: var(--color-gray4) url("/src/assets/img/ico-img2.svg") center no-repeat;
          border-radius:.5rem;
          opacity:1;
          font-size:0;
        }
      }
      .v-field{
        .v-field__overlay,
        .v-field__loader,
        .v-label,
        .v-field__outline{
          display:none;
        }
        .v-chip{
          font-size:1.2rem
        }
      }
      .v-input__details{
        display:none;
      }
      .v-field__input{
        padding:.8rem 0;
        min-height:auto;
      }
      button.v-btn{
        display:block;
        width:5rem;
        height:5rem;
        line-height:5rem;
        text-align:center;
        color:var(--color-white);
        background: var(--color-gray4);
      }
    }
  }
  .input-txt-group{
    position:absolute;
    top:0;
    left:6rem;
    width:calc(100% - 12rem);
  }
  .btn01{
    position:absolute;
    top:0;
    right:0;
  }
  &.v1{
    .img-upload .v-input{
      display:flex;
      .v-input__control{
        margin-left:1rem;
        .v-field__field{
          align-items:center;
        }
      }
    }
  }
}

@media (max-width: 853px) {
  .inp-comment {
    .input-txt-group{
      input::placeholder{font-size: 1rem;}
      input::-webkit-input-placeholder{font-size: 1.1rem;}
      input:-moz-placeholder{font-size: 1.1rem;}
      input::-moz-placeholder{font-size: 1.1rem;}
      input:-ms-input-placeholder {font-size: 1.1rem;}
    }
  }
}

</style>
